export var FundingAccountDirection;
(function (FundingAccountDirection) {
    FundingAccountDirection["RECEIVABLES"] = "receivables";
    FundingAccountDirection["PAYABLES"] = "payables";
    FundingAccountDirection["RECEIVABLES_AND_PAYABLES"] = "receivables_and_payables";
})(FundingAccountDirection || (FundingAccountDirection = {}));
export var FundingAccountProcessingChannels;
(function (FundingAccountProcessingChannels) {
    FundingAccountProcessingChannels["ACH"] = "ach";
    FundingAccountProcessingChannels["CHECK"] = "check";
    FundingAccountProcessingChannels["NONE"] = "none";
    FundingAccountProcessingChannels["RTP"] = "rtp";
})(FundingAccountProcessingChannels || (FundingAccountProcessingChannels = {}));
